import type { ButtonState, TickInput } from '../sim/input';

/**
 * Merge two per-tick inputs (keyboard + gamepad) into the one TickInput the sim sees. Pure and
 * DOM-free so the merge semantics are unit-testable: the LARGER move vector wins whole (no
 * averaging — half of two sticks is a speed nerf, not a blend), buttons OR field-by-field so an
 * edge from either device is never lost.
 */
const orButtons = (a: ButtonState, b: ButtonState): ButtonState => ({
  held: a.held || b.held,
  pressed: a.pressed || b.pressed,
  released: a.released || b.released,
});

export function mergeTickInputs(a: TickInput, b: TickInput): TickInput {
  const magA = Math.hypot(a.move.x, a.move.y);
  const magB = Math.hypot(b.move.x, b.move.y);
  const move = magB > magA ? b.move : a.move;
  return {
    move: { x: move.x, y: move.y },
    jump: orButtons(a.jump, b.jump),
    roll: orButtons(a.roll, b.roll),
    sprint: orButtons(a.sprint, b.sprint),
  };
}
